<div class="add-item-dialog-header"
    style="padding: 30px 24px 0; display: flex; justify-content: space-between; align-items: center;">
    <h1 style="font-size: 24px;">
        Label Creation Issue!
    </h1>
    <button (click)="closeDialog()"><i class="fas fa-times" style="font-size: 24px; color: red;"></i></button>
</div>




<div mat-dialog-content>
    <div class="container" style="max-width: 600px;">
        <div class="row">
            <div class="col-md-12">
                <h4 style="font-size: 18px; color: #444;">
                    Payment Processed Successfully <br>
                </h4>
                <p>
                    Unable to create shipment, one or more parameters were invalid.
                </p>
                <p>
                    Shippn Team will arrange the pick up for this shipment
                    and get back to you shortly!
                </p>
            </div>
        </div>
    </div>

</div>


<div mat-dialog-actions style="justify-content: flex-end;">
    <button mat-flat-button color="primary" class="shippn-mat-btn" (click)="closeDialog()"
        cdkFocusInitial>Shipments</button>
</div>